import { styled } from 'styled-components';
import { Route } from 'react-router-dom';
import React, { FC, Suspense } from 'react';
import { Box, ErrorBoundary } from '@idk-web/core-ui';
import { SentryRoutes } from '@/sentry';
import routes from '@/components/form/routes';
import Layout from '@/components/form/Layout';
import ScheduledMaintenanceMessage from '@/components/common/ScheduledMaintenanceMessage';
import BrowserSupportMessage from '@/components/common/BrowserSupportMessage';

const ErrorScreen = React.lazy(() => import('@/components/error/ErrorScreen'));
const LoginCallback = React.lazy(
  () => import('@/components/common/auth/LoginCallback'),
);
const ViewFormScreen = React.lazy(
  () => import('@/components/form/view/ViewFormScreen'),
);
const NotFoundScreen = React.lazy(
  () => import('@/components/notFound/NotFoundScreen'),
);

const Container = styled(Box).attrs({
  direction: 'vertical',
})``;

const FormApp: FC = () => {
  return (
    <Container>
      <ErrorBoundary fallback={ErrorScreen}>
        <BrowserSupportMessage />
        <ScheduledMaintenanceMessage />
        <Suspense fallback={null}>
          <SentryRoutes>
            <Route
              path={`${routes.authCallback}/*`}
              element={<LoginCallback redirect={routes.home} />}
            />
            <Route
              path={routes.viewFormByCompanyAndName}
              element={<ViewFormScreen />}
            />
            <Route path={routes.viewFormByName} element={<ViewFormScreen />} />
            <Route path={routes.home} element={<ViewFormScreen />} />
            <Route
              path="*"
              element={
                <Layout>
                  <NotFoundScreen />
                </Layout>
              }
            />
          </SentryRoutes>
        </Suspense>
      </ErrorBoundary>
    </Container>
  );
};

export default FormApp;
